import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CursorType,
  ModalType,
  setCursorType,
  setModal,
} from "@/store/globalSettingsSlice";
import { useDarkModeStore } from "@/store/zustand/darkModeStore";
import { useCanvasId } from "@/utils/utils";
import { useDesignTokensStore } from "../../DesignTokens/store/designTokensStore";
import { DESIGN_TOOLBAR_SHORTCUTS } from "../constants/designToolbarShortcuts";

export const useDesignToolbarShortcuts = () => {
  const dispatch = useDispatch();
  const showModal = useSelector((state: any) => state.globalSettings.showModal);
  const canvasId = useCanvasId();
  const firstLoadDone = useDesignTokensStore((state) => state.firstLoadDone);
  const canvasDarkMode = useDarkModeStore(
    (state) => state.canvasDarkModeStates[canvasId] || false,
  );

  const handleShortcut = useCallback(
    (shortcutKey: string, event?: KeyboardEvent) => {
      if (event?.repeat) return;

      const shortcut = DESIGN_TOOLBAR_SHORTCUTS[shortcutKey];
      if (!shortcut) return;

      // Handle modal toggles
      if (shortcut.modalType) {
        if (showModal === shortcut.modalType) {
          dispatch(setModal(ModalType.None));
        } else {
          dispatch(setModal(shortcut.modalType));
          dispatch(setCursorType({ cursorType: CursorType.Pointer }));
        }
        return;
      }

      // Handle cursor type changes
      if (shortcut.cursorType) {
        dispatch(setModal(ModalType.None));
        dispatch(setCursorType({ cursorType: shortcut.cursorType }));
        return;
      }

      // Handle special cases
      if (shortcutKey === "TOGGLE_DARK_LIGHT_MODE" && firstLoadDone) {
        const newDarkMode = !canvasDarkMode;
        useDarkModeStore.getState().setCanvasDarkMode(canvasId, newDarkMode);
      }
    },
    [dispatch, showModal, firstLoadDone, canvasDarkMode, canvasId],
  );

  return { handleShortcut };
};
